import { render, staticRenderFns } from "./Semi.vue?vue&type=template&id=2c1fb188&scoped=true&"
import script from "./Semi.vue?vue&type=script&lang=js&"
export * from "./Semi.vue?vue&type=script&lang=js&"
import style0 from "./Semi.vue?vue&type=style&index=0&id=2c1fb188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fb188",
  null
  
)

export default component.exports